import { render, staticRenderFns } from "./FormalizacionActasRegresoComparecientes.vue?vue&type=template&id=6c3505d8&scoped=true"
import script from "./FormalizacionActasRegresoComparecientes.vue?vue&type=script&lang=js"
export * from "./FormalizacionActasRegresoComparecientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3505d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3505d8')) {
      api.createRecord('6c3505d8', component.options)
    } else {
      api.reload('6c3505d8', component.options)
    }
    module.hot.accept("./FormalizacionActasRegresoComparecientes.vue?vue&type=template&id=6c3505d8&scoped=true", function () {
      api.rerender('6c3505d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/FormalizacionActasRegresoComparecientes.vue"
export default component.exports